import { call, put, takeEvery } from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';
import * as MessageActions from '../../../comn/message/actions/comnMessageAction';
import * as Actions from '../actions/mainDashAction';
import * as Apis from '../apis/mainDashApi';

function* listStcsDay(action: ActionType<typeof Actions.STCS_DAY.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.mainDashAPI.stcsDay, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.STCS_DAY.success({
        data: data
      })
    );
  } catch (error) {
    yield put(Actions.STCS_DAY.failure(error));
  }
}

function* listStcsArea(action: ActionType<typeof Actions.STCS_AREA.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.mainDashAPI.stcsArea, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.STCS_AREA.success({
        data: data
      })
    );
  } catch (error) {
    yield put(Actions.STCS_AREA.failure(error));
  }
}

function* listGroup(action: ActionType<typeof Actions.GROUP_LIST.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.mainDashAPI.groupList, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.GROUP_LIST.success({
        data: data
      })
    );
  } catch (error) {
    yield put(Actions.GROUP_LIST.failure(error));
  }
}

function* listDron(action: ActionType<typeof Actions.DRON_LIST.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.mainDashAPI.dronList, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.DRON_LIST.success({
        data: data
      })
    );
  } catch (error) {
    yield put(Actions.DRON_LIST.failure(error));
  }
}

export function* mainDashSaga() {
  yield takeEvery(Actions.STCS_DAY.request, listStcsDay);
  yield takeEvery(Actions.STCS_AREA.request, listStcsArea);
  yield takeEvery(Actions.GROUP_LIST.request, listGroup);
  yield takeEvery(Actions.DRON_LIST.request, listDron);
}
